import { render, staticRenderFns } from "./AutomationSettings.vue?vue&type=template&id=2364dc84"
import script from "./AutomationSettings.vue?vue&type=script&lang=js"
export * from "./AutomationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports